import styled from "styled-components";
import { styleSheet } from "../../assets/styles/global";
import { Input, Select, Modal } from 'semantic-ui-react'

// Responsive Wrapper
export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 2rem;
  
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
  }
`;

// Main Container - Matches Login Box style
export const Schedules = styled.div`
  position: relative;
  width: 45%; /* Desktop width */
  padding: 0 3rem;
  background: #fff;
  border-radius: 3rem; 
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    width: 100%;
    padding: 2rem;
  }
`;

export const Title = styled.h2`
  font-family: ${styleSheet.mainFont};
  font-size: 2.4rem;
  color: #54278b; /* Menu Purple */
  text-align: center;
  margin-bottom: 3rem;
  font-weight: bold;
`;

// Row Containers
// Row Containers
export const TimeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column; /* Stack Title above Inputs */
  align-items: center; /* Center horizontally */
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const FieldContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center; /* Center inputs */

  width: 100%;

  @media (max-width: 1000px) {
    flex-direction: row; /* Force row */
    width: 100%;
    align-items: center; 
    justify-content: flex-start;
  }
`;

export const TimeTitle = styled.label`
  font-size: 1.6rem;
  color: #54278b; /* Menu Purple */
  margin-bottom: 0.5rem;
  font-weight: 600;
  text-align: center; /* Ensure text is centered */
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
 
  
  @media (max-width: 1000px) {
    width: 40%;
    min-width: 100px;
    margin-bottom: 1rem;
  }
`;

// ... (other styles remain unchanged unless they use color)

export const StyledInput = styled.input`
  display: flex;
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 0.1rem solid #c3c3c3;
  width: 100%;
  outline: none;
  
  &:focus {
    border-color: #54278b; /* Menu Purple */
  }
`;

export const StyledTextArea = styled.textarea`
  display: flex;
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 0.1rem solid #c3c3c3;
  width: 100%;
  outline: none;
  resize: vertical;
  background: #fff;
  font-family: ${styleSheet.mainFont};

  &:focus {
    border-color: #54278b; /* Menu Purple */
  }
`;

// ...

export const SelectContainer = styled(Select)`
  &&& {
    width: 100%;
    min-width: 100px;
    font-size: 1.4rem;
    border-radius: 0.8rem;
    border: 0.1rem solid #c3c3c3;
    padding: 0.8rem !important;
    display: flex;
    align-items: center;
    
    .text {
      color: #2c2c2c;
    }
  }
`;

export const InputWorkerHours = styled(StyledInput)`
  text-align: center;
`;

export const TimeInput = styled.input`
  display: flex;
  padding: 0.8rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 1px solid #e0e0e0; /* Delicate border */
  width: 8rem; /* Fit approx 5 chars comfortably */
  outline: none;
  text-align: center;
  font-family: ${styleSheet.mainFont};
  color: #2c2c2c;
  background: #fdfdfd;
  transition: all 0.2s;

  &:focus {
    border-color: #54278b; /* Menu Purple Focus */
    box-shadow: 0 0 0 2px rgba(84, 39, 139, 0.1);
  }

  &::placeholder {
    color: #ccc;
  }
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 1.6rem; /* Slightly larger */
  color: #FF8C00; /* Menu Orange */
  font-weight: 400;
  margin-bottom: 0.5rem;
  font-family: ${styleSheet.mainFont};
`;

export const DelicatePlusButton = styled.button`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 0;
  background: #FF8C00; /* Menu Orange */
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.2s, background 0.2s;

  &:hover {
    transform: scale(1.1);
    background: #e07b00;
  }
`;

// Global overrides for MUI Labels within the Modal
export const MuiLabelOverrides = styled.div`
  width: 100%;
  
  & .MuiInputLabel-root {
    color: #FF8C00 !important; /* Menu Orange */
    font-size: 1.6rem !important; /* Larger */
    font-family: ${styleSheet.mainFont} !important;
    
    &.Mui-focused {
      color: #FF8C00 !important;
    }
  }

  & .MuiOutlinedInput-root {
    border-radius: 0.8rem !important;
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #FF8C00 !important; /* Orange Focus Border */
    }
  }
`;

// Override for Semantic UI Modal Header
export const ModalHeaderOverride = styled.div`
  & .ui.modal > .header {
    color: #54278b !important; /* Menu Purple */
    font-family: ${styleSheet.mainFont} !important;
    text-transform: uppercase;
  }
`;

// Section Titles
export const OSDetailTitle = styled.h3`
  font-size: 1.8rem;
  color: #54278b; /* Standard Dark */
  margin: 2rem 0 1rem 0;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
  width: 100%;
`;
export const OSDetail = styled.div`
  width: 40%; /* Desktop width */
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

// ...

// Table Styles
export const TableContainer = styled.div`
  width: 100%;
  margin: 2rem 0;
  border-radius: 1rem;
  border: 1px solid #eee;
`;

export const TableColumnText = styled.span`
  font-size: 1.4rem;
  font-weight: bold;
  color: #54278b; /* Menu Purple */
`;

export const TableDataText = styled.span`
  font-size: 1.4rem;
  color: #2c2c2c;
`;

// ...

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  font-size: 1.6rem;
  background: #54278b; /* Menu Purple */
  color: #fff;
  border: 0;
  border-radius: 0.8rem;
  cursor: pointer;
  transition: 0.2s background ease-out;
  margin: 1rem;
  font-weight: 600;

  &:hover {
    background: #401f68; /* Darker Purple */
    filter: brightness(0.9);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: #fff;
  color: #54278b; /* Menu Purple */
  border: 1px solid #54278b; /* Menu Purple */

  &:hover {
    background: #f0f0f0;
  }
`;

export const DeleteButton = styled(PrimaryButton)`
  background: #ff4d4f; /* Red for delete */
  &:hover {
    background: #cf1322;
  }
`;


export const ButtonTable = styled.button`
  position: absolute;
  right: 5px;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 0;
  margin-right: .5rem;
  background: #eee;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const IntervalContainer = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 1rem;
`;

export const Option = styled.option``;

export const AddButtonWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  position: absolute;
  right: -45px;
  bottom: 5px;

  @media (max-width: 1000px) {
    position: relative;
    right: auto;
    bottom: auto;
    margin-top: 1rem;
    align-self: flex-end; /* Align to right within column flow, or center if preferred */
    margin-left: auto;
  }
`;

export const StyledModal = styled(Modal)`
  &&& {
    @media (min-width: 1001px) {
      width: 70% !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    }

    /* Mobile behavior remains default (fullscreen) */
  }
`;



















